import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useGoogleSheetCreateSelectors } from '../../../Google/Sheets/UseGoogleSheetCreate/useGoogleSheetCreateSelectors';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useGoogleSheetCreateSelectorsWidget = () => {
    const { components } = useGoogleSheetCreateSelectors({});
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "FolderSelector" }), components.FolderSelector, _jsx(Typography, { variant: "h5", children: "CreateSpreadsheetInFolder" }), components.CreateSpreadsheetInFolder, _jsx(Typography, { variant: "h5", children: "FoldertUrlLink" }), components.FoldertUrlLink, _jsx(Typography, { variant: "h5", children: "CreatedSheetUrlLink" }), components.CreatedSheetUrlLink, _jsx(Typography, { variant: "h5", children: "WorkingSpinner" }), components.WorkingSpinner] })), [components]);
    return {
        name: 'useGoogleSheetCreateSelectors',
        category: 'composite',
        component,
    };
};
